<template>
    <div >

        <!----
        <div class="btn-wrapper text-center">
                <base-button block v-on:click="createReport('default')" :disabled="reportCreation.includes(location)" :key="key" :icon="(reportCreation.includes(location)) ? 'fas fa-spinner fa-pulse' :'fas fa-file-alt'" type="primary"
                             title="Bericht erstellen">aktuelle Berichtsperiode</base-button>
                <base-button block type="secondary" v-on:click="customPeriod = !customPeriod" icon="ni ni-calendar-grid-58">Benutzerdefinierter Zeitraum</base-button>
        </div>--->

        <div >
            <h4>Berichtsart:</h4>
            <b-form-radio-group
                    autofocus
                    required
                    v-model="reportData.reportType"
                    button-variant="outline-primary"
                    :options="reports"
                    outline
                    buttons
                    style="width: 100%;"
                    name="radios-btn-default"
                    stacked
            >
            </b-form-radio-group>
        </div>

        <div >
            <h4 class="mt-4">Berichtszeitraum:</h4>
            <b-form-radio-group
                    autofocus
                    required
                    v-model="reportData.type"
                    button-variant="outline-primary"
                    :options="options"
                    outline
                    buttons
                    style="width: 100%;"
                    name="radios-btn-default"
                    stacked
            >
            </b-form-radio-group>
        </div>



        <fade-transition>
            <div v-if="reportData.type === 'custom'" class="row mt-3">
                <div class="col">
                    <base-input
                            label="von"
                            class="col-form-label col-form-label-lg"
                            placeholder="von"
                    >
                        <flat-pickr slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="config"
                                    class="form-control form-control-alternative form-control-lg datepicker"
                                    v-model="reportData.startsAt">
                        </flat-pickr>
                    </base-input>
                </div>
                <div class="col">
                    <base-input
                            label="bis"
                            class="col-form-label col-form-label-lg"
                            placeholder="bis"
                    >
                        <flat-pickr slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="config"
                                    class="form-control form-control-alternative form-control-lg datepicker"
                                    v-model="reportData.endsAt">
                        </flat-pickr>
                    </base-input>
                </div>
            </div>
        </fade-transition>
    </div>

</template>

<script>
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import FlatPickr from "vue-flatpickr-component/src/component";

    export default {
        name:"ExportSettings",
        components:{FlatPickr, FadeTransition},
        props: ['reportData'],
        data() {
            return {
                key: 34,
                reports: [
                    { text: 'Gesamtbericht', value: 'all' },
                    { text: 'Spielerschutzmaßnahmen', value: 'activities' },
                    { text: 'OASIS', value: 'oasis' },
                    { text: 'Aufgaben (alle)', value: 'tasks' },
                ],
                options: [
                    { text: 'Aktueller Berichtszeitraum', value: 'default' },
                    { text: 'Aktueller Monat', value: 'actmonth' },
                    { text: 'Letzter Monat', value: 'lastmonth' },
                    { text: 'Aktuelles Jahr', value: 'actyear' },
                    { text: 'Letztes Jahr', value: 'lastyear' },
                    { text: 'Benutzerdefinierter Zeitraum', value: 'custom' }
                ],
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
            }
        }
    }
</script>

<style scoped>

</style>